import { usePageTitle } from '@app/hooks/usePageTitle';
import TokenSalesWidget from '@widgets/trades/token-sales';

const TokenSalesPage = () => {
  usePageTitle('Token Sales');

  return <TokenSalesWidget />;
};

export default TokenSalesPage;
